/**
 * Pixel coordinates for overlaying filled-in values onto
 * `reimbursement-form-template.pdf` (the church's official
 * Reimbursement/Check Request Authorization Form).
 *
 * The template is a static, non-fillable PDF (plain lines, not AcroForm
 * fields), so values are drawn as text on top of it. Coordinates were
 * measured directly off the template's underline/checkbox positions and
 * are in pdf-lib's bottom-left-origin point system for US Letter
 * (612 x 792).
 */

export const PAGE_WIDTH = 612;
export const PAGE_HEIGHT = 792;

// Single-line text fields: baseline position to draw each value at.
export const FIELD_POSITIONS = {
  date: { x: 430, y: 665 },
  payableTo: { x: 192, y: 610 },
  checkAmount: { x: 436, y: 610 },
  phone: { x: 119, y: 583 },
  purposeLine1: { x: 254, y: 555 },
  purposeLine2: { x: 71, y: 536 },
  needBy: { x: 119, y: 508 },
  requestedBy: { x: 381, y: 508 },
  approvedBy: { x: 143, y: 481 },
  grandTotal: { x: 254, y: 103 },
};

// Max text widths (points) available for the two purpose lines before
// wrapping to the next line.
export const PURPOSE_LINE_WIDTHS = {
  purposeLine1: 265,
  purposeLine2: 448,
};

// Checkbox glyph positions - an "X" is drawn at each position when that
// option is selected.
export const CHECKBOX_POSITIONS = {
  reimbursement: { x: 119.5, y: 637 },
  checkRequest: { x: 255, y: 637 },
  donation: { x: 381.5, y: 637 },
  boardMember: { x: 119.5, y: 453 },
  youthLeader: { x: 255, y: 453 },
  other: { x: 381.5, y: 453 },
};

// Receipts table geometry: 14 rows, 3 columns (Purchased From / Amount $ /
// Purpose). rowBoundaries has 15 entries (top border of row 1 through the
// bottom border of row 14), measured from the top of the page.
const ROW_BOUNDARIES_FROM_TOP = [
  388.4, 408.1, 427.8, 447.5, 467.2, 486.9, 506.5, 526.2, 545.9, 565.6, 585.3,
  605.0, 624.6, 644.3, 664.0,
];

export const MAX_RECEIPT_ROWS = ROW_BOUNDARIES_FROM_TOP.length - 1;

// Baseline y (pdf-lib coordinates) for the text in row `index` (0-based).
export const receiptRowBaselineY = (index) => {
  const rowBottomFromTop = ROW_BOUNDARIES_FROM_TOP[index + 1];
  return PAGE_HEIGHT - rowBottomFromTop + 5;
};

export const RECEIPT_COLUMNS = {
  purchasedFrom: { x: 71.4, maxWidth: 175 },
  // Amount is right-aligned against the column's right edge.
  amount: { rightX: 329.4, maxWidth: 75 },
  purpose: { x: 337.4, maxWidth: 183 },
};
